var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-above"},[_c('h1',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.org.name))]),_vm._v(" "),_c('InPageNav',{attrs:{"options":[
					{
						text : 'Overview',
						path : '/orgs/'+_vm.org.id,
					},
					{
						text : 'Team',
						path : '/orgs/'+_vm.org.id+'/team',
					},
					{
						text : 'Settings',
						path : '/orgs/'+_vm.org.id+'/settings',
					},
					{
						text : 'Billing',
						path : '/orgs/'+_vm.org.id+'/billing',
					} ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }